var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',[_c('ul',{staticClass:"mb-6"},_vm._l((_vm.stepps),function(step,index){return _c('li',{key:index,class:_vm.current === index + 1 ? '' : 'gray',style:(_vm.stepps === 5 ? 'width: 18%' : '')})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }